import script from "./StaffPinPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffPinPrompt.vue?vue&type=script&setup=true&lang=js"

import "./StaffPinPrompt.vue?vue&type=style&index=0&id=9d055d74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d055d74"]])

export default __exports__